import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
export default {
  InsertUploadDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      fileList: input.fileList,
      uploadDocumentTypeId: input.uploadDocumentType,
      fileDocumentTypeId: input.fileDocumentType,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/UploadDocument/InsertUploadDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  VoidUploadDocument(uploadDocumentId) {
    let _input = {
      uploadDocumentId: uploadDocumentId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/UploadDocument/VoidUploadDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReferenceInvoiceWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
      expenseType: input.expenseType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceInvoiceWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceQuotationWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
      expenseType: input.expenseType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceQuotationWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceCreditNoteWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceCreditNoteWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceDebitNoteWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceDebitNoteWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceBillingNoteWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceBillingNoteWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceDepositWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceDepositWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceReceiptWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceReceiptWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoReferenceJournalWithUploadDocument(input) {
    let _input = {
      transactionId: input.transactionId,
      uploadDocumentList: input.uploadDocumentList,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/ReferenceJournalWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoUpdateIsReceivedWhtWithUploadDocument(input) {
    let _input = {
      whtId: input.whtId,
      isReceivedWHT: input.isReceivedWht,
      paymentInOutFlowType: input.paymentInOutFlowType,
      whtRegisterNumber: input.registerWht.registerNumber,
      whtRegisterDate: input.registerWht.registerDate,
      remark: input.registerWht.remark,
      file: input.registerWht.file,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/UploadDocument/UpdateIsReceivedWhtWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoGetDocumentTextOCRFromMongo(uploadDocumentIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      uploadDocumentIdList: uploadDocumentIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/UploadDocument/GetDocumentTextOCRFromMongo", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUploadDocumentByIdList(uploadDocumentIdList) {
    let _input = {
      data: {
        uploadDocumentIdList: uploadDocumentIdList,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/UploadDocument/GetUploadDocumentByIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateFileDocumentTypeToUploadDocument(input) {
    let _input = {
      uploadDocumentId: input.uploadDocumentId,
      fileDocumentType: input.fileDocumentType,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/UploadDocument/UpdateFileDocumentTypeToUploadDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
